// =================================================================
// CIQURA LABS - DATA CONFIGURATION (SEO OPTIMIZED 2026)
// =================================================================

export const trainingPrograms = [
  {
    id: 1,
    slug: 'cybersecurity',
    title: 'Cybersecurity & Ethical Hacking',
    category: 'Cybersecurity',
    level: 'Beginner to Professional',
    duration: '6 Months / 10 Months',
    description:
      'Indore\'s most comprehensive cybersecurity training. Master ethical hacking, VAPT, and SOC operations at our Vijay Nagar lab with 100% internship support from Ciqur24 Bengaluru.',
    image: 'https://images.pexels.com/photos/60504/security-protection-anti-virus-software-60504.jpeg',
    altText: 'Ethical Hacking and SOC Analyst training at Ciqura Labs Indore',
    skills: [
      'Ethical Hacking',
      'Penetration Testing (VAPT)',
      'SOC Operations & SIEM',
      'Network Security',
      'Threat Intelligence',
      'Incident Response'
    ],
    careers: [
      'SOC Analyst',
      'Cybersecurity Consultant',
      'Penetration Tester',
      'Security Engineer'
    ],
    curriculum: [
      {
        module: 'Security Fundamentals & GRC',
        topics: ['Security Foundations', 'Threat Landscape', 'Compliance Frameworks']
      },
      {
        module: 'Advanced Network Security',
        topics: ['Firewall Architecture', 'IDS/IPS Operations', 'VPN & Encryption']
      },
      {
        module: 'Offensive Security (Ethical Hacking)',
        topics: ['Advanced Recon', 'Scanning & Enumeration', 'System Exploitation']
      },
      {
        module: 'Web & Mobile App Security',
        topics: ['OWASP Top 10 2026', 'SQLi & XSS', 'API Pentesting']
      },
      {
        module: 'Defense-in-Depth (SOC)',
        topics: ['SIEM (Splunk/Sentinel)', 'Incident Response', 'Threat Hunting']
      }
    ],
    tools: ['Kali Linux', 'Wireshark', 'Metasploit', 'Burp Suite', 'Nmap', 'Splunk', 'CrowdStrike']
  },

  {
    id: 4,
    slug: 'aiml',
    title: 'AI & Machine Learning (AIML)',
    category: 'Data Science',
    level: 'Intermediate',
    duration: '6 Months / 10 Months',
    description:
      'Learn Generative AI and Machine Learning in Indore. Our project-based curriculum covers Python, Deep Learning, and LLM fine-tuning for modern IT roles.',
    image: 'https://images.pexels.com/photos/3861958/pexels-photo-3861958.jpeg',
    altText: 'Artificial Intelligence and Machine Learning classes in Vijay Nagar Indore',
    skills: [
      'Python for Data Science',
      'Generative AI & LLMs',
      'Deep Learning',
      'Natural Language Processing',
      'Computer Vision'
    ],
    careers: [
      'AI Engineer',
      'Machine Learning Developer',
      'Data Scientist'
    ],
    curriculum: [
      {
        module: 'Python & Mathematical Foundations',
        topics: ['NumPy & Pandas', 'Linear Algebra', 'Data Visualization']
      },
      {
        module: 'Supervised & Unsupervised ML',
        topics: ['Regression & Classification', 'Clustering', 'Random Forests']
      },
      {
        module: 'Neural Networks & Deep Learning',
        topics: ['TensorFlow/PyTorch', 'CNN for Vision', 'RNN for Sequences']
      },
      {
        module: 'Generative AI Specialist',
        topics: ['Prompt Engineering', 'LLM Fine-tuning', 'Vector Databases']
      }
    ],
    tools: ['Python', 'TensorFlow', 'PyTorch', 'Jupyter', 'HuggingFace', 'OpenAI API']
  },

  {
    id: 5,
    slug: 'grc',
    title: 'Governance, Risk & Compliance (GRC)',
    category: 'Cybersecurity Management',
    level: 'Professional',
    duration: '6 Months / 10 Months',
    description:
      'A specialized GRC course in Indore for aspiring auditors and risk managers. Master ISO 27001, NIST, and global compliance standards with real audit simulations.',
    image: 'https://images.unsplash.com/photo-1510915228340-29c85a43dcfe',
    altText: 'GRC and Information Security Audit training in Indore',
    skills: [
      'IT Risk Management',
      'Compliance Frameworks',
      'ISO 27001 Lead Auditor Prep',
      'SOC2 & HIPAA Audits'
    ],
    careers: [
      'GRC Analyst',
      'Information Security Auditor',
      'Compliance Manager'
    ],
    curriculum: [
      {
        module: 'GRC Ecosystem',
        topics: ['Governance Frameworks', 'Risk Assessment', 'Compliance Strategy']
      },
      {
        module: 'International Standards',
        topics: ['ISO 27001:2022', 'NIST Cyber Framework', 'GDPR/DPDP Act']
      }
    ],
    tools: ['StandardFusion', 'LogicGate', 'AuditBoard', 'Risk Management Toolkits']
  },

  {
    id: 7,
    slug: 'full-stack-development',
    title: 'Full Stack Web Development (MERN)',
    category: 'Software Development',
    level: 'Beginner to Advanced',
    duration: '8 Months',
    description:
      'Become a job-ready Full Stack Developer in Indore. Master the MERN stack (MongoDB, Express, React, Node.js) with real-world enterprise projects and cloud deployment.',
    image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c',
    altText: 'Full Stack Web Development training center in Indore',
    skills: [
      'React & Redux',
      'Node.js & Express',
      'NoSQL & SQL Databases',
      'JWT Authentication',
      'Cloud Deployment'
    ],
    careers: ['MERN Stack Developer', 'Software Engineer', 'Backend Developer'],
    curriculum: [
      {
        module: 'Modern Frontend Mastery',
        topics: ['React Hooks', 'State Management', 'Tailwind CSS']
      },
      {
        module: 'Scalable Backend Architecture',
        topics: ['Node.js Event Loop', 'RESTful API Design', 'Express Middleware']
      },
      {
        module: 'Database & Security',
        topics: ['MongoDB Modeling', 'PostgreSQL', 'Auth0/Firebase Auth']
      }
    ],
    tools: ['Docker', 'AWS (EC2/S3)', 'GitHub Actions', 'VS Code', 'Postman']
  },

  {
    id: 8,
    slug: 'python-developer',
    title: 'Professional Python Developer',
    category: 'Programming',
    level: 'Beginner to Professional',
    duration: '6 Months',
    description:
      'Master Python programming from scratch. Focused on automation, backend development, and data scraping for the 2026 tech market in Indore.',
    image: 'https://images.unsplash.com/photo-1515879218367-8466d910aaa4',
    altText: 'Python Programming and Automation course in Vijay Nagar Indore',
    skills: [
      'Core Python',
      'Object Oriented Programming',
      'Django & Flask',
      'Selenium Automation',
      'REST API Development'
    ],
    careers: [
      'Python Developer',
      'Automation Engineer',
      'Backend Developer'
    ],
    curriculum: [
      {
        module: 'Python Essentials',
        topics: ['Advanced Data Structures', 'Error Handling', 'Decorators']
      },
      {
        module: 'Enterprise Web Frameworks',
        topics: ['Django Architecture', 'Flask Microservices', 'ORM & Database']
      },
      {
        module: 'Task Automation',
        topics: ['Web Scraping', 'File Handling', 'API Automation']
      }
    ],
    tools: ['PyCharm', 'VS Code', 'Git', 'Docker', 'Selenium']
  }
];

// ================================
// Why Choose Us (Local Authority)
// ================================

export const whyChooseUs = [
  {
    id: 1,
    title: 'Industry Mentors',
    description: 'Learn directly from Ciqur24 engineers with 10+ years of active field experience.'
  },
  {
    id: 2,
    title: 'Corporate Pedigree',
    description: 'Ciqura Labs is the official training arm of Ciqur24 IT Services Bengaluru.'
  },
  {
    id: 3,
    title: 'Enterprise Labs',
    description: 'Hands-on practice on live SOC environments and actual threat intelligence tools.'
  },
  {
    id: 4,
    title: '100% Placement Support',
    description: 'Direct internship opportunities at our Bengaluru HQ for professional track students.'
  },
  {
    id: 5,
    title: 'Small Focus Batches',
    description: 'Maximum 15 students per batch at our Vijay Nagar lab for personalized guidance.'
  },
  {
    id: 6,
    title: 'Strategic Location',
    description: 'Prime Indore location at Shagun Arcade, easily accessible via A.B. Road.'
  }
];

// ================================
// Testimonials (Authentic Feedback)
// ================================

export const testimonials = [
  {
    id: 1,
    name: 'Aman Sharma',
    role: 'Junior SOC Analyst',
    text: 'Ciqura Labs is hands-down the best cybersecurity institute in Indore. The transition from theory to the live SOC lab was seamless and helped me crack my interview.',
    image: 'https://images.unsplash.com/photo-1527689368864-3a821dbccc34'
  },
  {
    id: 2,
    name: 'Riya Gupta',
    role: 'Cloud Engineer',
    text: 'The Azure and Cloud security training gave me the edge I needed. The small batch size meant the mentors could focus on my specific doubts.',
    image: 'https://images.pexels.com/photos/1181316/pexels-photo-1181316.jpeg'
  },
  {
    id: 3,
    name: 'Vikram Singh',
    role: 'MERN Developer',
    text: 'Practical, real-world development training. We didn\'t just write code; we deployed projects on AWS. Truly industrial-grade training in Indore.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e'
  }
];

// ================================
// Contact Info (Google Map Ready)
// ================================

export const contactInfo = {
  phone: '+91 9303998387',
  email: 'training@ciqur24.com',
  address:
    '113, First Floor, Shagun Arcade, Above Apna Sweets, A.B. Road, Vijay Nagar, Indore, Madhya Pradesh 452010',
  social: {
    linkedin: 'https://www.linkedin.com/company/ciqura-labs/',
    twitter: '#',
    facebook: 'https://www.facebook.com/people/Ciqura-Labs/61586091034604/',
    instagram: 'https://www.instagram.com/ciqura_labs/'
  }
};